import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import IconChevron from "@/assets/icons/chevron.svg?react";
import IconClose from "@/assets/icons/close.svg?react";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "@/components/ui/scroll-area.tsx";

type ChallengeRuleDrawerProps = {
  info: string;
};

const ChallengeRuleDrawer = (props: ChallengeRuleDrawerProps) => {
  const { info } = props;
  const { t } = useTranslation();

  return (
    <Drawer shouldScaleBackground setBackgroundColorOnScale={false}>
      <DrawerTrigger asChild>
        <p className="text-xs font-medium leading-130 text-white flex-y-center cursor-pointer">
          {t("more_details")}
          <IconChevron
            width="16"
            height="16"
            className="text-gray-1"
            strokeWidth="1.6"
          />
        </p>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader className="flex justify-between gap-2">
          <DrawerTitle>{t("challenge.rules_info")}</DrawerTitle>
          <DrawerClose>
            <IconClose width={20} height={20} className="text-white" />
          </DrawerClose>
        </DrawerHeader>
        <ScrollArea className="h-[78vh] overflow-auto">
          <DrawerBody>
            <div
              className="whitespace-pre-line [&_*]:!whitespace-pre-line"
              dangerouslySetInnerHTML={{ __html: info }}
            />
          </DrawerBody>
        </ScrollArea>
      </DrawerContent>
    </Drawer>
  );
};

export default ChallengeRuleDrawer;
